const FAULTS = new Set(['silent', 'blocked', 'missing', 'busy'])

export function studentHelpTarget(opts: {
  micAccess: Record<string, string | null>
  camAccess: Record<string, string | null>
  isTeacher: (identity: string) => boolean
}): string | null {
  const ids = new Set<string>()
  for (const [id, access] of [...Object.entries(opts.micAccess), ...Object.entries(opts.camAccess)]) {
    if (!opts.isTeacher(id) && access && FAULTS.has(access)) ids.add(id)
  }
  return ids.size === 1 ? [...ids][0] : null
}

export function studentHelpDevice(identity: string, micAccess: Record<string, string | null>): 'mic' | 'camera' {
  return FAULTS.has(micAccess[identity] ?? '') ? 'mic' : 'camera'
}

/** The asked device was faulty at send time; only its subsequent ok is evidence. */
export function studentDeviceOk(
  identity: string,
  device: 'mic' | 'camera',
  micAccess: Record<string, string | null>,
  camAccess: Record<string, string | null>,
): boolean {
  return (device === 'mic' ? micAccess : camAccess)[identity] === 'ok'
}
